(() => {
  const videoUrl = 'https://www.youtube-nocookie.com/embed/1DyLAHB4CqU?autoplay=1&rel=0';

  function init(root) {
    if (root.dataset.czRylanVideoReady === 'true') return;

    const trigger = root.querySelector('[data-cz-rylan-video-trigger]');
    const dialog = root.querySelector('[data-cz-rylan-video-dialog]');
    const close = root.querySelector('[data-cz-rylan-video-close]');
    const frame = root.querySelector('[data-cz-rylan-video-frame]');
    if (!trigger || !dialog || !close || !frame || !dialog.showModal) return;

    root.dataset.czRylanVideoReady = 'true';

    trigger.addEventListener('click', () => {
      frame.src = videoUrl;
      dialog.showModal();
      close.focus();
    });

    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      frame.removeAttribute('src');
      trigger.focus();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-cz-rylan-video-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
